module.exports = __webpack_public_path__ + "img/instagram.76770c29.svg";